import styled from 'styled-components';
import { Nav, NavLink } from 'reactstrap';
import { fontWeight, fontSize, resetLinkStyle } from '@whitelabel/helpers/style/type';
import { mediaBreakpointUp, gridGutterWidth } from '@whitelabel/helpers/style/grid';
import { spacer, multiply } from '@whitelabel/helpers/style/units';
import StyledPolicyIconBase from '../../styled/StyledPolicyIcon';

export const StyledNav = styled(Nav).attrs(() => ({ tabs: true }))`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const StyledNavLink = styled(NavLink)`
  ${resetLinkStyle}
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${multiply(spacer, 9.5)};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize('sm')};
  text-align: center;

  ${mediaBreakpointUp('md')`
    max-width: ${multiply(spacer, 11)};
    font-size: ${fontSize('md')};
  `};

  && {
    margin-top: ${gridGutterWidth('sm')};
    padding-bottom: ${multiply(spacer, 0.75)};
    ${mediaBreakpointUp('md')`
        margin-top: ${gridGutterWidth('md')};
       `}

    ${mediaBreakpointUp('lg')`
        margin-top: ${gridGutterWidth('lg')};
      `}
  }
`;

export const StyledPolicyIcon = styled(StyledPolicyIconBase)`
  width: ${multiply(spacer, 2)};
  height: ${multiply(spacer, 2)};
  margin-bottom: ${multiply(spacer, 0.5)};

  ${mediaBreakpointUp('md')`
      width: ${multiply(spacer, 3)};
      height: ${multiply(spacer, 3)};
  `};
`;
